import React from 'react';
import { Empty } from 'antd-mobile'
import empty from './images/empty.png'
import AiErrorBlock from '../AiErrorBlock'
import './index.scss'

export interface AiEmptyProps {
    image?: React.ReactNode | string
    description?: React.ReactNode | string
    imageStyle?: object
    _style?: object,
    err?: boolean
    retry?: () => void
}


const AiEmpty: React.FC<AiEmptyProps> = ({ err = false, image = null, description = '暂无数据', imageStyle = {}, _style = { background: '#ECEDEE' }, ...props }) => {
    const handleRetry = () => {
        if (props?.retry) {
            props?.retry()
        }
    }
    if (err) {
        return <AiErrorBlock retry={handleRetry} />
    }
    return image ? <Empty image={image} description={<div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '70vw', textAlign: 'center' }}>{description}</div>} imageStyle={imageStyle} style={_style} /> : <Empty image={empty} description={<div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '70vw', textAlign: 'center' }}>{description}</div>} imageStyle={{ width: '2.133333rem', height: '1.68rem', ...imageStyle }} style={_style} />
}

export default AiEmpty
